import ChessHandAndBrainSvg from '@/assets/icons/hand-and-brain.svg?component';

export default {
  name: 'IconChessHandAndBrain',
  components: { ChessHandAndBrainSvg },
  props: {
    color: { type: String, default: 'rgb(0,0,0)' },
    size: { type: String, default: '1em' },
    width: { type: String, default: null },
    height: { type: String, default: null },
    tooltipEnabled: { type: Boolean, default: true },
  },
  computed: {
    svgStyle() {
      return { height: this.height || this.size, width: this.width || 'auto', color: this.color, display: 'block' };
    },
    tooltipOptions() {
      return { value: this.$t('chessVariants.hand-and-brain'), class: 'tt-sm', disabled: !this.tooltipEnabled };
    },
  },
};
